module.exports = __webpack_public_path__ + "fonts/fontawesome/fa-sharp-duotone-thin-100.woff2";